import { makeStyles, Theme } from "@material-ui/core";

import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";

export const useStyles = makeStyles<Theme>((theme) => {
  const { gray40, gray80, gray30 } = useNormalizedBrandPaletteValues(theme);

  return {
    header: {
      color: gray40,
      fontWeight: "bold",
      marginBottom: theme.spacing(1),
    },
    shopifyHeader: {
      marginBottom: theme.spacing(1),
    },
    disabledButton: {
      backgroundColor: gray80,
    },
    activeHeader: {
      color: theme.palette.common.black,
    },
    bold: {
      fontWeight: "bold",
    },
    formText: {
      color: gray40,
      fontSize: 12,
      lineHeight: 1.25,
      display: "inline-block",
    },
    shortButton: {
      height: 48,
      minWidth: 160,
    },
    lastStep: {
      borderLeftColor: "transparent",
      paddingBottom: 0,
    },
    list: {
      margin: 0,
      padding: 0,
      "& > li": {
        "&::marker": {
          fontSize: "1.5rem",
        },
        "&:not(:last-child)": {
          marginBottom: theme.spacing(2),
        },
      },
    },
    shopifyIntegrationInstallInstructions: {
      paddingInlineStart: theme.spacing(3),
      color: gray40,
    },
    shopifyIntegrationSecondaryText: {
      color: gray30,
    },
  };
});
